import React, {useState, useContext} from 'react';
import {UserContext} from './components/UserContext';

import {
    Grid,
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    Divider,
    TextField, ThemeProvider,
} from '@mui/material';
import ReplyIcon from '@mui/icons-material/Reply';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import NewMailModal from "./components/NewMailModal";
import ReplyModal from "./components/ReplyModal";
import theme from "./theme";
import axios from "axios";
import ForwardModal from "./components/ForwardModal";

const bgColor = '#1F1F1F'
const selectColor = '#353739'
const selectStroke = 'rgba(127,127,127,0.2)'
const buttonGreySecondary = '#7F7F7F'

const senderColor = '#FFFFFF'
const previewColor = '#7F7F7F'
const subjectColor = '#F8FAFC'

async function fetchMails(email_address, password) {

    try {
        const response = await axios.get('https://boring-ride.95-216-35-79.plesk.page:5000/fetch_emails', {
            params: {
                email_address: email_address,
                password: password
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200) {
            const fetchedEmails = response.data.emails;
            const emails = fetchedEmails.map((email, index) => ({
                id: index + 1,
                sender: email.sender,
                content: email.content,
                received_date: email.received_date,
                subject: email.subject
            }));

            return emails;
        } else {
            console.error(`Failed to fetch emails: ${response.status}`);
            return [];
        }
    } catch (error) {
        console.error(`Failed to fetch emails: ${error}`);
        return [];
    }
}


function App() {
    const userContext = useContext(UserContext);
    const [selectedEmail, setSelectedEmail] = useState(null);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    

    const [emails, setEmails] = useState([]);

    const logout = () => {
        setEmails([]);
        userContext.setEmail(null);
        userContext.setPassword(null);
        setSelectedEmail(null)
    };


    const fetchAndSetEmails = async () => {
        const fetchedEmails = await fetchMails(email, password);
        setEmails(fetchedEmails);

        userContext.setEmail(email);
        userContext.setPassword(password);

    };


    const truncateText = (text, maxLength) => text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    const [showTextField, setShowTextField] = useState(false);

    const handleMenuItemClick = (event, index) => {
        setShowTextField(true);
    };

    const handleSendGeneratedReply = () => {
        setShowTextField(false);
    };

    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const [replyModal, setReplyModal] = useState(null);

    const handleOpenReplyModal = (email) => {
        setReplyModal(email);
    };

    const handleCloseReplyModal = () => {
        setReplyModal(null);
    };

    const [forwardModal, setForwardModal] = useState(null);

    const handleOpenForwardModal = (email) => {
        setForwardModal(email);
    };

    const handleCloseForwardModal = () => {
        setForwardModal(null);
    };

    return (

        <ThemeProvider theme={theme}>


            <Grid container sx={{bgcolor: bgColor, color: 'white', height: '100vh'}}>

                <Grid item xs={2} sx={{
                    bgcolor: '#262626',
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}>
                    <Box>
                        {emails.length == 0 && (
                            <>
                                <TextField
                                    id="email"
                                    label="E-Mail"
                                    value={email}
                                    onChange={(event) => setEmail(event.target.value)}
                                    variant="outlined"
                                />
                                <TextField
                                    id="password"
                                    label="Passwort"
                                    type="password"
                                    value={password}
                                    onChange={(event) => setPassword(event.target.value)}
                                    variant="outlined"
                                />


                                <Button
                                    variant="contained"
                                    disableElevation
                                    fullWidth
                                    onClick={fetchAndSetEmails}
                                >
                                    Einloggen
                                </Button>
                            </>
                        )}
                        {emails.length > 0 && (
                            <Button
                                variant="contained"
                                disableElevation
                                fullWidth
                                onClick={logout}
                                sx={{mt: 2}}
                            >
                                Abmelden
                            </Button>
                        )}

                    </Box>

                    <Button onClick={handleOpenModal}
                            variant="containedGrey"
                            startIcon={<AddOutlinedIcon/>}
                            fullWidth>
                        Neue Mail schreiben
                    </Button>

                    <NewMailModal open={openModal} handleClose={handleCloseModal}/>

                </Grid>


                <Grid item xs={4} onClick={() => {
                    setSelectedEmail(null);
                    setShowTextField(false);
                }} sx={{
                    border: `1px solid ${selectStroke}`,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: '16px'
                }}>

                    <Grid item container sx={{p: 4, borderBottom: `1px solid ${selectStroke}`}}>
                        <TextField id="search"
                                   label="Suchen"
                                   sx={{
                                       width: '100%',
                                       mb: 3.25,
                                   }}>
                        </TextField>
                    </Grid>


                    <Grid container item sx={{p: 4}}>
                        {emails.map(email => (
                            <Card key={email.id}
                                  sx={{
                                      bgcolor: email.id === selectedEmail?.id ? selectColor : 'transparent',
                                      color: 'white',
                                      width: '100%',
                                      boxShadow: email.id === selectedEmail?.id ? `inset 0 0 0 1px ${selectStroke}` : 0,
                                      border: 'none'
                                  }}
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedEmail(email);
                                      setShowTextField(false);
                                  }}
                            >
                                <CardContent
                                    sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div>
                                        <Typography variant="h5" component="h2"
                                                    sx={{fontSize: 18, fontWeight: 'medium', color: senderColor}}>
                                            {email.sender}
                                        </Typography>
                                        <Typography variant="subtitle1"
                                                    sx={{fontSize: 16, fontWeight: 'regular', color: subjectColor}}>
                                            {email.subject}
                                        </Typography>
                                        <Typography variant="body2" component="p"
                                                    sx={{fontSize: 12, fontWeight: 'normal', color: previewColor}}>
                                            {truncateText(email.content, 80)}
                                        </Typography>
                                    </div>
                                    <Typography variant="body2" component="p"
                                                sx={{fontSize: 12, fontWeight: 'normal', color: previewColor}}>
                                        {email.received_date}
                                    </Typography>
                                </CardContent>
                            </Card>
                        ))}

                    </Grid>

                </Grid>

                <Grid item xs={6} sx={{
                    borderTop: `1px solid ${selectStroke}`,
                    borderRight: `1px solid ${selectStroke}`,
                    borderBottom: `1px solid ${selectStroke}`,
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    {selectedEmail && (
                        <>

                            <Box sx={{flex: '0 0 150px', px: 4, pt: 2}}>
                                <Typography variant="h4" component="h1" sx={{mb: 1}}>
                                    {selectedEmail.subject}
                                </Typography>
                                <Typography variant="h6" component="h2" sx={{mb: 2}}>
                                    {selectedEmail.sender}
                                </Typography>
                            </Box>

                            <Box sx={{flex: '1 1 auto', overflowY: 'auto', px: 4}}>
                                <Typography variant="body1" component="p">
                                    {selectedEmail.content}
                                </Typography>
                            </Box>

                            <Divider sx={{backgroundColor: selectStroke}}/>

                            <Box sx={{flex: '0 0 auto', px: 4, py: 2}}>
                                <Button variant="contained" startIcon={<ReplyIcon/>}
                                        onClick={() => handleOpenReplyModal(selectedEmail)} sx={{
                                    mr: 4,
                                }}>
                                    Antworten
                                </Button>
                                <Button variant="outlined" sx={{
                                    textTransform: 'none',
                                    borderColor: buttonGreySecondary,
                                    color: buttonGreySecondary,
                                    mr: 1,
                                    px: 3,
                                    py: 2,
                                    borderRadius: 2
                                }}>
                                    Allen antworten
                                </Button>
                                <Button onClick={() => handleOpenForwardModal(selectedEmail)} variant="outlined" sx={{
                                    textTransform: 'none',
                                    borderColor: buttonGreySecondary,
                                    color: buttonGreySecondary,
                                    mr: 1,
                                    px: 3,
                                    py: 2,
                                    borderRadius: 2
                                }} endIcon={<ReplyIcon/>}>
                                    Weiterleiten
                                </Button>

                            </Box>
                        </>
                    )}
                </Grid>


                <ReplyModal email={replyModal} handleClose={handleCloseReplyModal}/>
                <ForwardModal email={forwardModal} handleClose={handleCloseForwardModal}/>
            </Grid>
        </ThemeProvider>

    );
}

export default App;
